// extracted by mini-css-extract-plugin
export var expandable__content = "expandable-module--expandable__content--f5956";
export var expandable__icon = "expandable-module--expandable__icon--ba105";
export var expandable__labels = "expandable-module--expandable__labels--b15ef";
export var expandable__title = "expandable-module--expandable__title--6f79c";
export var grid = "expandable-module--grid--10bf6";
export var gridWithRowGap = "expandable-module--grid--with-row-gap--fad76";
export var maxWidthContainer = "expandable-module--max-width-container--d0bcb";
export var mt0 = "expandable-module--mt-0--b82e8";
export var mt1 = "expandable-module--mt-1--9e0af";
export var mt2 = "expandable-module--mt-2--59d94";
export var mt3 = "expandable-module--mt-3--83fda";
export var mt4 = "expandable-module--mt-4--556f4";
export var mt5 = "expandable-module--mt-5--93388";
export var mt6 = "expandable-module--mt-6--c6de3";
export var removeVisuallyHidden = "expandable-module--remove-visually-hidden--68e02";
export var visuallyHidden = "expandable-module--visually-hidden--1ceef";
export var widgetBase = "expandable-module--widget-base--21ec7";